export default __webpack_public_path__ + "static/media/logo-dark.cc0e8d3a.svg";